import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconInfo = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <circle cx='12' cy='12' r='9' />
      <path d='M12 11v5M12 8h.01' />
    </g>
  </SDIcon>
)

export default IconInfo
